import { FC } from "react";
import styles from "../Pricing.module.scss";

interface Props {
    link: string;
}

const Button: FC<Props> = ({ link }) => {
    return (
        <a href={link} className={styles.button}>
            <span>Details</span>
            <img width={20} height={20} src="/images/scam/arrow.svg" alt="" />
        </a>
    );
};

export default Button;
